import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AnnouncementBar from "@/components/AnnouncementBar";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-noir">
    <AnnouncementBar />
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <CartDrawer />
  </div>
);

export default Layout;
